import React from 'react'
import './radioButton.scss'

interface RadioButtonProps {
    id: string;
    value: { id: number, name: string };
    name: string;
    isChecked: boolean;
    label: string;
    radioRef?: any;
    onChange: any;
}

const RadioButton = (props: RadioButtonProps) => {

    const { id, value, name, isChecked, label, radioRef = null } = props;

    return (
        <div className="a-radio-button-container" ref={radioRef}>
            <input
                type="radio"
                id={id}
                value={JSON.stringify(value)}
                name={name}
                checked={isChecked}
                onChange={props.onChange}
                className="a-radio-button-container__radio"
            />
            <label
                htmlFor={id}
                className="a-radio-button-container__title"
            >
                <p>
                    {label}
                </p>
            </label>
        </div>
    )
}

export default RadioButton